
import React from 'react';
import { MdSearch } from 'react-icons/md';
import { useForm } from 'react-hook-form';

type InputProps = {
    placeholder: string;
    searchQuery: string;
    setSearchQuery: (newSearchQuery: string) => void;
}

type SearchForm = {
    newSearchQuery: string;
}

export function NavigationSearchBar({placeholder = '', searchQuery, setSearchQuery}: InputProps){
    const {register, handleSubmit} = useForm({
        defaultValues: {
            newSearchQuery: searchQuery
        }
    });

    const onSubmit = ({newSearchQuery}: SearchForm) => setSearchQuery(newSearchQuery);

    return (
        <form className="relative" onSubmit={handleSubmit(onSubmit)}>
                <input
                    type="search"
                    {...register('newSearchQuery')}
                    placeholder={placeholder}
                    className="browser-auto-fill-atlantis h-10 px-5 pr-10 rounded-full text-sm focus:outline-none bg-transparent border border-white placeholder-white"
                    style={{width: '300px'}} />
                <button type="submit" className="absolute -ml-8 mt-2">
                    <MdSearch className='h-6 w-6 fill-current' size={32}/>
                </button>
        </form>
    );
}
